import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import {
  CustomerIcon,
  HourGlassIcon,
  ProductsIcon,
  RevenueIcon,
} from '@features/ui/icons';
import { Card, CardStat } from '@features/ui';
import { UserByPlatform } from '@features/admin/dashboard/UsersByPlatform.tsx';
import { getPayoutDashboardSummary } from '@src/services/reports';
import { formatCentsAsDollars } from '@lib/utils';
import { toast } from 'react-toastify';

interface PayoutsDashboardProps {
  startDate?: string | null;
  endDate?: string | null;
}

export const PayoutsDashboard: FC<PayoutsDashboardProps> = ({
  startDate,
  endDate,
}) => {
  const [summaryData, setSummaryData] = useState({
    active_users: 0,
    active_accounts: 0,
    payout_total: 0,
    pa_accounts: 0,
  });

  const fetchSummaryData = useCallback(async () => {
    try {
      const data = await getPayoutDashboardSummary();

      setSummaryData(data);
    } catch (error) {
      console.error('Failed to fetch payout dashboard summary:', error);
      toast.error(
        'Failed to load payout dashboard summary. Please try again later.'
      );
    }
  }, []);

  useEffect(() => {
    fetchSummaryData();
  }, [fetchSummaryData]);

  const data = useMemo(
    () => [
      {
        id: '1',
        desc: 'Active Users',
        value: summaryData.active_users.toLocaleString(),
        icon: <CustomerIcon fill={'#DC342E'} />,
      },
      {
        id: '2',
        desc: 'Active Accounts',
        value: summaryData.active_accounts.toLocaleString(),
        icon: <HourGlassIcon fill={'#DC342E'} />,
      },
      {
        id: '3',
        desc: 'Payout Total',
        value: formatCentsAsDollars(summaryData.payout_total),
        icon: <RevenueIcon fill={'#DC342E'} />,
      },
      {
        id: '4',
        desc: 'PA Accounts',
        value: summaryData.pa_accounts.toLocaleString(),
        icon: <ProductsIcon fill={'#DC342E'} />,
      },
    ],
    [summaryData]
  );

  return (
    <div className={'flex flex-col gap-y-5'}>
      <div className={'flex gap-5 flex-wrap'}>
        {data.map((item) => {
          return (
            <CardStat
              key={item.id}
              desc={item.desc}
              icon={
                <div
                  className={
                    'bg-[#DC342E26] h-13 w-13 flex items-center justify-center rounded-[16px]'
                  }
                >
                  {item.icon}
                </div>
              }
              value={item.value}
            />
          );
        })}
      </div>
      <Card className={'bg-card-stat px-0'}>
        <UserByPlatform endDate={endDate} startDate={startDate} />
      </Card>
    </div>
  );
};
